<p class="more-paragraph">{{ _displayText }} <span (click)="handleClickMore($event)" class="more" *ngIf="showMore">({{ 'common.more' | translate }})</span></p>
